import Vue from 'vue';
import Router from 'vue-router';
import { NAME_ROUTES } from './features/core/utils';

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    routes: [
        {
            path: NAME_ROUTES.HOME.path,
            component: () => import('./features/home/views/HomePage.vue'),
            children: [
                {
                    path: NAME_ROUTES.ITEM_DETAIL.path,
                    component: () => import('./features/item/PageItemDetail.vue'),
                    name: NAME_ROUTES.ITEM_DETAIL.name,
                    props: route => ({
                        id: route.params.id,
                        token: route.params.token
                    })
                },
                {
                    path: NAME_ROUTES.ITEM_WITH_SINISTERS.path,
                    component: () => import('./features/item_with_sinisters/PageItemWithSinisters.vue'),
                    name: NAME_ROUTES.ITEM_WITH_SINISTERS.name,
                    props: route => ({
                        id: route.params.id,
                        token: route.params.token
                    })
                },
            ],
            beforeEnter: (from, to, next) => {
                next();
            }
        },
        {
            path: '*',
            name: 'Not Found',
            component: () => import('./features/home/views/PageNotFound.vue')
          }
    ]
});

router.beforeEach((to, from, next) => {
    document.title = `Gestión de Polígonos`
    next();
  });

export default router;
